import {
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { msalInstance } from "../main";
import { scopes } from "../authConfig";
import { emailAuth } from "@utils/emailAuthUtils.ts";

export const baseUrl = import.meta.env.VITE_API_BASE_URL;

const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: async (headers) => {
    const account = msalInstance.getActiveAccount();
    const emailToken = emailAuth.getJwtToken();

    if (account) {
      const response = await msalInstance.acquireTokenSilent({
        scopes,
        account,
      });

      const token = response.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    } else if (emailToken && !emailAuth.isTokenExpired()) {
      headers.set("Authorization", `Bearer ${emailToken}`);
      return headers;
    } else {
      throw Error("No active account! Sign in before making requests");
    }
  },
});

// If the server returns a 401 Unauthorized status code, dispatch the logout action
export const baseQueryWithLogout: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    //api.dispatch(setError("TokenExpiredException"));
    //await api.dispatch(logout());
  }

  return result;
};
